import React from "react";
import Flex from "../../../../structure/Flex";

interface RadioButtonsProps {
  value: any;
  setValue: React.Dispatch<any>;
  name: string;
  options?: Array<{ id: any; value: string }>;
  className?: string;
}

const RadioButtons: React.FC<RadioButtonsProps> = ({
  value,
  setValue,
  name,
  options,
  className = "p-3",
}) => {
  return (
    <Flex className="flex-wrap">
      {options &&
        options.map((option) => (
          <Flex key={option.id} className="my-1">
            <input
              type="radio"
              value={option.id}
              name={name}
              className="hidden"
              id={`radio-${name}-${option.id}`}
              checked={value === option.id}
              onChange={() => {
                setValue(option.id);
              }}
            />
            <label
              className={`rounded-lg cursor-pointer mr-2 ${
                value === option.id
                  ? "text-dark border border-dark"
                  : "border-accent border text-subtitle"
              } ${className}`}
              htmlFor={`radio-${name}-${option.id}`}
            >
              {option.value}
            </label>
          </Flex>
        ))}
    </Flex>
  );
};

export default RadioButtons;
